import { render } from "./SideBarLink.vue?vue&type=template&id=e767963a&scoped=true"
import script from "./SideBarLink.vue?vue&type=script&lang=js"
export * from "./SideBarLink.vue?vue&type=script&lang=js"

import "./SideBarLink.vue?vue&type=style&index=0&id=e767963a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e767963a"]])

export default __exports__